export default __webpack_public_path__ + "static/media/form-submission2.e1710703.gif";